import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import classnames from 'classnames';

import { AppState } from 'services/types';
import { selectPinnedSidebar } from 'services/ui/selectors';
import './styles.scss';

interface OwnProps {
    children: React.ReactNode;
    compact?: boolean;
}

interface ConnectedProps {
    pinned: ReturnType<typeof selectPinnedSidebar>;
}

type Props = OwnProps & ConnectedProps;

export class PageTitleAndFiltersPusher extends React.PureComponent<Props> {
    render(): React.ReactElement {
        const { children, compact, pinned } = this.props;
        return (
            <div
                className={classnames('page-title-and-filters-pusher', {
                    open: pinned,
                    compact
                })}
            >
                <div className="page-title-and-filters-pusher-wrapper">
                    <div className="page-title-and-filters-pusher-container">
                        <div
                            className="page-title-and-filters-pusher-inner"
                            id="content"
                        >
                            {children}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    pinned: selectPinnedSidebar
});

export default connect(mapStateToProps)(PageTitleAndFiltersPusher);
